import { RootState } from "../../store";

export default function getCurrentSession({ sessions }: RootState) {
  return sessions.currentSession
    ? sessions.activeSessions[sessions.currentSession]
    : undefined;
}
